let locales = {
    ModalHistoryNotesByPAState_title: 'Riepilogo di tutte le note eseguite in questa fase',
    ModalHistoryNotesByPAState_dateCreatedNote: 'Data di creazione della nota'
};

export default locales;